import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { CourtScheduleConfigurationDto, CreateCourtConfigurationDto } from "../../../models/court/dto/configuration.dto";
import { GET_COURT_CONFIGURATIONS_QUERY_KEY } from "./useGetCourtConfigurations";

export const useCreateCourtConfiguration = (courtId: number) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationFn: (input: Omit<CreateCourtConfigurationDto, 'courtId'>) =>
            apiClient.fetchApi<CourtScheduleConfigurationDto, CreateCourtConfigurationDto>({
                method: 'POST',
                endpoint: `courts/${courtId}/configurations`,
                body: { ...input, courtId }
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_COURT_CONFIGURATIONS_QUERY_KEY(courtId)
            });
        },
        onError: () => {
            toast({ title: translate('error'), status: 'error', duration: 3000, position: 'top-right' });
        }
    });
};